import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useState } from "react";
const HeroHeaderContext = createContext({});
export function HeroHeaderProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [container, setContainer] = useState();
  let t1;
  if ($[0] !== container) {
    t1 = {
      container,
      setContainer
    };
    $[0] = container;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const value = t1;
  let t2;
  if ($[2] !== children || $[3] !== value) {
    t2 = <HeroHeaderContext.Provider value={value}>{children}</HeroHeaderContext.Provider>;
    $[2] = children;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function useHeroHeader() {
  return useContext(HeroHeaderContext);
}